import React from 'react';
import { Briefcase, CheckCircle2 } from 'lucide-react';
import { Badge } from './ui/badge';
import { experienceData } from '../data/mock';

export const ExperienceSection = () => {
  return (
    <section id="experience" className="py-32 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-16 tracking-tight">
          {experienceData.title}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Highlights */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center">
                <Briefcase className="w-5 h-5 text-black" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-normal text-black">Career Highlights</h3>
            </div>
            <ul className="space-y-5">
              {experienceData.highlights.map((highlight, index) => (
                <li key={index} className="flex items-start gap-4">
                  <CheckCircle2 className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                  <span className="text-gray-600 font-light leading-relaxed">
                    {highlight}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Expertise */}
          <div>
            <h3 className="text-xl font-normal text-black mb-8">Deep Expertise In</h3>
            <div className="flex flex-wrap gap-3">
              {experienceData.expertise.map((skill, index) => (
                <Badge
                  key={index}
                  variant="outline"
                  className="text-sm font-light px-5 py-2.5 border-gray-200 text-gray-700 bg-white hover:bg-rose-600 hover:text-white hover:border-rose-600 transition-all duration-300 cursor-default"
                >
                  {skill}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
